module.exports = __webpack_public_path__ + "static/media/writech.b85a173a.png";